import styled from 'styled-components';

export const DepatureContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.NL20};
  border-radius: 8px;
  width: 100%;
  padding: 10px;
  height: fit-content;
  margin-top: 6px;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    padding: 20px;
    margin-top: 0px;
  }
`;
export const DepatureContainerHeader = styled.div`
  width: 100%;
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  height: 31px;
`;
export const PersonInfoContainer = styled.div`
  margin-left: auto;
  line-height: 31px;
`;
export const HeaderInfoContainer = styled.div`
  line-height: 31px;
  display: flex;
  gap: 10px;
`;

export const DesktopFlightItemContainer = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.NL0};
  padding: 16px;
  border-bottom: 1px #ebecf0 solid;
`;
export const HeaderWrapper = styled.div`
  display: flex;
  gap: 8px;
`;
export const SeturBadgeContainer = styled.div`
  border-radius: 4px;
  background-color: ${({ theme }) => theme.palette.BR50};
  height: 19px;
  line-height: 15px;
  padding-left: 8px;
  padding-right: 8px;
  align-items: center;
  justify-content: center;
  display: flex;
`;
export const FlightDetailsContainer = styled.div`
  text-decoration: underline;
  margin-left: auto;
  cursor: pointer;
`;
export const BodyWrapper = styled.div`
  display: flex;
  margin-top: 12px;
  align-items: center;
  max-height: 60px;
`;
export const DepatureInfoBox = styled.div<{ isListing?: boolean }>`
  max-width: ${({ isListing }) => (isListing ? '79px' : '102.5px')};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  flex: 1 0 0;
  margin-left: 12px;
  line-height: 18px;
`;

export const RadioButton = styled.input`
  width: 20px;
  height: 20px;
  accent-color: ${({ theme }) => theme.palette.burntSienna};
`;

export const ArrowContainer = styled.div`
  & span {
    display: block;
    text-align: center;
  }
`;
export const LandingInfoBox = styled.div<{ isListing?: boolean }>`
  max-width: ${({ isListing }) => (isListing ? '79px' : '102.5px')};
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
  flex: 1 0 0;
  margin-left: 12px;
  line-height: 18px;
`;
export const PriceWrapper = styled.div`
  text-align: right;
  margin-left: auto;
  height: 60px;
  align-items: end;
  display: flex;
  flex-direction: column;
`;
export const PriceInfoWrapper = styled.div`
  margin-top: auto;
  margin-bottom: -1px;
`;
export const MobileInfoWrapper = styled.div``;
export const Container = styled.div<{ isListing?: boolean }>`
  background-color: ${({ theme }) => theme.palette.NL0};
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 8px;
  padding-top: ${({ isListing }) => (isListing ? '16px' : '10px')};
  padding-bottom: ${({ isListing }) => (isListing ? '16px' : '10px')};

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    display: grid;
    grid-template-columns: auto auto;
    gap: 10px;
    margin-left: 0px;
    margin-right: 0px;
    padding-left: ${({ isListing }) => (isListing ? '16px' : '40px')};
    padding-right: ${({ isListing }) => (isListing ? '16px' : '40px')};
    margin-top: 10px;
  }
`;
export const LandingContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.NL20};
  border-radius: 8px;
  width: 100%;
  padding: 10px;
  height: fit-content;
  margin-top: 20px;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    padding: 20px;
    margin-top: 0px;
  }
`;
export const TransferWrapper = styled.div`
  margin-top: 10px;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 24px;
  }
`;

export const MobileFlightItemContainer = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.NL0};
  padding: 8px;
  border-bottom: 1px #ebecf0 solid;
`;
export const MobileHeaderWrapper = styled.div`
  display: flex;
  gap: 3px;
`;
export const MobileHeaderInfoWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 5px;
  max-height: 18px;
`;
export const MobileBodyWrapper = styled.div`
  display: flex;
  margin-top: 30px;
  align-items: center;
  max-height: 66px;
`;
export const MobileDepatureInfoBox = styled.div`
  min-width: 73px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  flex: 1 0 0;
  margin-left: 12px;
  line-height: 18px;
`;
export const MobileLandingInfoBox = styled.div`
  min-width: 73px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
  flex: 1 0 0;
  line-height: 18px;
`;

export const MobilePriceTextWrapper = styled.div`
  max-width: 100%;
`;
export const MobilePriceWrapper = styled.div`
  text-align: right;
  margin-left: 10px;
  height: 73px;
  align-items: end;
  display: flex;
  flex-direction: column;
`;
export const InfoBox = styled.div<{ isListing?: boolean }>`
  width: 100%;
  border-radius: 8px;
  display: flex;
  background-color: ${({ theme }) => theme.palette.lightClearBlue};
  grid-column: 1 / span 2;
  padding: 10px;
  margin-top: ${({ isListing }) => (isListing ? '0px' : '20px')};
  gap: 5px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 0px;
  }
`;
